package empiresmp.feature.gallery.ui

import androidx.compose.runtime.Composable
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.maxHeight
import com.varabyte.kobweb.compose.ui.modifiers.maxWidth
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.theme.shapes.Rect
import com.varabyte.kobweb.silk.theme.shapes.clip
import empiresmp.components.alert.AlertDialog
import empiresmp.components.fade.Crossfade
import empiresmp.feature.gallery.model.GalleryItem
import empiresmp.feature.gallery.model.url
import org.jetbrains.compose.web.css.percent
import ru.astrainteractive.kobwebx.core.theme.composable.LocalSitePalette

@Suppress("LongMethod")
@Composable
internal fun GallerModalComposable(
    item: GalleryItem? = null,
    onClose: () -> Unit
) {
    val theme = LocalSitePalette.current

    AlertDialog(open = item != null, onDismiss = onClose) {
        item?.let { item ->
            val index = remember { mutableStateOf(0) }
            Column(
                modifier = Modifier.fillMaxSize(),
                verticalArrangement = Arrangement.SpaceBetween,
                horizontalAlignment = Alignment.CenterHorizontally
            ) {
                val url = item.images[index.value % item.images.size].url
                Box(Modifier)
                Box(
                    modifier = Modifier
                        .maxHeight(80.percent)
                        .margin(theme.dimens.S),
                    contentAlignment = Alignment.Center
                ) {
                    Crossfade(
                        targetState = url,
                        modifier = Modifier.fillMaxSize()
                    ) { url ->
                        Image(
                            src = url,
                            modifier = Modifier
                                .maxHeight(95.percent)
                                .maxWidth(95.percent)
                                .clip(Rect(theme.dimens.S))
                                .onClick {
                                    it.stopPropagation()
                                    it.preventDefault()
                                }
                        )
                    }
                }
                Row(
                    modifier = Modifier.fillMaxWidth(),
                    horizontalArrangement = Arrangement.spacedBy(theme.dimens.S, Alignment.CenterHorizontally)
                ) {
                    if (item.images.size > 1) {
                        NextComposable(
                            type = NextType.PREV,
                            onClick = {
                                val newValue = index.value - 1
                                index.value = if (newValue < 0) item.images.lastIndex else newValue
                            }
                        )
                    }
                    if (item.images.size > 1) {
                        NextComposable(
                            type = NextType.NEXT,
                            onClick = {
                                val newValue = index.value + 1
                                index.value = if (newValue > item.images.lastIndex) 0 else newValue
                            }
                        )
                    }
                }
            }
        }
    }
}
